import React, { useEffect, useRef } from 'react';
import styles from './Hero.module.css';

function Hero() {
  const terminalRef = useRef(null);

  useEffect(() => {
    const fullLines = [
      'Welcome to clarity mode...',
      'Taking the Tailored Approach...',
      'Automations booting up...',
      'Growth algorithms syncing...',
      'Your time? Unlocked...',
      'Scaling pain? Disappearing...',
      ''
    ];

    const fullMessage = fullLines.join('\n');
    let i = 0;

    const typeNextChar = () => {
      if (i <= fullMessage.length) {
        const currentSlice = fullMessage.slice(0, i);
        if (terminalRef.current) terminalRef.current.textContent = currentSlice;
        i++;
        setTimeout(typeNextChar, 28);
      }
    };

    typeNextChar();
  }, []);

  return (
    <header className={styles.hero}>
      <div className={styles.terminalWrapper}>
        <div className={styles.terminalOverlay}>
          <div ref={terminalRef} className={styles.terminalText}></div>
          <a href="#book" className={styles.terminalCTA}>
            🔷 Click Here ➡️ Unlock Your Growth Audit 🔷
          </a>
        </div>
      </div>
    </header>
  );
}

export default Hero;
